import { CircularProgress } from '@mui/material';
import React from 'react';

function Loader() {
  return (
    <div className="loader-wrapper">
      <CircularProgress role="status" />
      <span className="loading-text">Loading...</span>
    </div>
  );
}

export default Loader;
